import i18n from 'i18n';

export const SERVER_ERROR = () => i18n.t('messages:serverError');
export const REPEATED_EMAILS_ERROR = () => i18n.t('messages:repeatedEmails');
export const REPEATED_CONSTRUCTION_NAME_ERROR = () => i18n.t('messages:repeatedConstructionName');
export const SEND_EMAIL_RESET_PASSWORD_MESSAGE = () => i18n.t('messages:sendEmailResetPassword');
export const PASSWORD_CHANGED_SUCCESSFULLY = () => i18n.t('messages:passwordChanged');
export const HAS_LOCKED_FILES_REQUEST_PLOT = () => i18n.t('messages:hasLockedFilesRequestPlot');
export const HAS_LOCKED_FILES_REQUEST_PLOT_EXTENSION = () => i18n.t('messages:hasLockedFilesRequestPlotExtension');
export const REVENUE_ERROR = () => i18n.t('messages:revenueError');
export const LOAD_VERSION_FILE = () => i18n.t('messages:loadVersionFile');

export const openError = (entityName: string) => {
  return `${i18n.t('messages:openError')} ${entityName}`;
};

export const loadError = (entityName: string) => {
  return `${i18n.t('messages:loadError')} ${entityName}`;
};

export const updateError = (entityName: string) => {
  return `${i18n.t('messages:updateError')} ${entityName}`;
};

export const createError = (entityName: string) => {
  return `${i18n.t('messages:createError')} ${entityName}`;
};

export const updateSuccess = (entityName: string) => {
  return `${i18n.t('messages:updateSuccess')} ${entityName}`;
};

export const createSuccess = (entityName: string) => {
  return `${i18n.t('messages:createSuccess')} ${entityName}`;
};

export const requisitonSuccess = (entityName: string) => {
  return `${i18n.t('messages:requisitionSuccess')} ${entityName}`;
};

export const requisitonError = (entityName: string) => {
  return `${i18n.t('messages:requisitionError')} ${entityName}`;
};

export const aproveSuccess = (entityName: string) => {
  return `${i18n.t('messages:approveSuccess')} ${entityName}`;
};

export const aproveError = (entityName: string) => {
  return `${i18n.t('messages:approveError')} ${entityName}`;
};

export const reproveSuccess = (entityName: string) => {
  return `${i18n.t('messages:reproveSuccess')} ${entityName}`;
};

export const reproveError = (entityName: string) => {
  return `${i18n.t('messages:reproveError')} ${entityName}`;
};

export const unreadNotificationError = () => {
  return i18n.t('messages:listUnreadNotificationError');
};

export const notificationError = () => {
  return i18n.t('messages:listNotificationError');
};

export const setNotificationToReadError = () => {
  return i18n.t('messages:setNotificationToRead');
};

export const listAllTenantOfUserError = () => {
  return i18n.t('messages:listTenantOfUserError');
};

export const extractErrorMessage = (e: any, fallback: string): string => {
  if (Array.isArray(e?.errors) && e.errors[0]?.Message) {
    return e.errors[0].Message;
  }

  if (e?.errors && typeof e.errors === 'object') {
    const firstFieldMessages = Object.values(e.errors)[0];
    if (Array.isArray(firstFieldMessages) && firstFieldMessages[0]) {
      return firstFieldMessages[0];
    }
  }

  return fallback;
};
